import { Loader as BulmaLoader } from "react-bulma-components";
import styled from "styled-components";

const LoaderWrapper = styled.div`
  && {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const SizedLoader = styled(BulmaLoader)<LoaderProps>`
  width: ${({ size }) => (size ? `${size}px` : "48px")};
  height: ${({ size }) => (size ? `${size}px` : "48px")};
`;

interface LoaderProps {
  size?: number;
}

export const LoaderContainer = styled.div`
  margin-top: 48px;
`;

export const Loader = ({ size }: LoaderProps) => (
  <LoaderWrapper data-testid="loading-spinner">
    <SizedLoader size={size} />
  </LoaderWrapper>
);

export default Loader;
